<template>
  <div
    ref="frisbuy-widget-gallery"
    :class="{ 'frisbuy-widget': true, 'frisbuy-class': true, 'frisbuy-vertical': isVerticalGallery, [`frisbuy-layout-${ gallerySettings.layout }`]: gallerySettings.layout, [`frisbuy-${ settings.customerCode }`]:true}"
    :style="[galleryStyle]"
  >
    <!-- <script
      src="https://connect.facebook.net/en_US/all.js"
      async=""
      type="application/javascript"
      v-if="settings.popup.shareButtons.fb"
    ></script> -->
    <div class="frisbuy-header">
      <div
        class="frisbuy-title"
        v-if="headerSettings.title || headerSettings.buttonTitle"
      >
        {{headerSettings.title}}<a
          v-if="headerSettings.buttonTitle"
          :href="headerSettings.buttonLink"
          >{{headerSettings.buttonTitle}}</a
        >
      </div>
      <div
        v-if="headerSettings.subTitle"
        class="frisbuy-subtitle"
        :style="[subTitleStyle]"
      >
        {{headerSettings.subTitle}}
      </div>
      <div v-if="headerSettings.html" v-html="headerSettings.html"></div>

      <div class="frisbuy-gallery-navigation">
        <div class="frisbuy-prev-navigation-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M13.6 7.99961L10 12.0968L13.517 16.0996"
              stroke="#131313"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div class="frisbuy-next-navigation-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M10.0001 16.1C11.406 14.5 12.1942 13.6029 13.6001 12.0029L10.083 8"
              stroke="#131313"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="frisbuy-categories" v-if="gallerySettings.filters.params">
      <a
        :href="`#tag=${filter.value ? filter.name : 'Все'}`"
        :class="{ 'frisbuy-category': true, 'frisbuy-active': filterValue == filter.value || (filterValue == null && !filter.value) }"
        v-for="filter in gallerySettings.filters.params"
        @click="chosenFilter(filter)"
        >{{filter.name}}</a
      >
    </div>
    <div class="frisbuy-gallery">
      <div
        :class="{ 'frisbuy-scroll-wrapper': true, 'no-scroll-width': !isVerticalGallery && scrollWidth < 0 }"
        :style="{ height: isVerticalGallery && gallerySettings.maxCols && `${ (containerItemHeight * gallerySettings.maxCols) }px`}"
        v-touch:swipe="swipeHandler"
        ref="postsScroll"
      >
        <div ref="swiper">
          <ul
            class="frisbuy-gallery-posts frisbuy-gallery-posts__sheme-lazurit swiper-wrapper"
            id="frisbuy-gallery-posts"
            :class="{
              'frisbuy-gallery-multiline': isLineRowsMode,
              [`frisbuy-scheme-${ gallerySettings.scheme }`]: gallerySettings.layout == 'tile' && gallerySettings.scheme
            }"
          >
            <template v-for="(post, index) in postList" :key="post.frisbuyPost.id">
              <frisbuy-gallery-post
                :post="post"
                class="swiper-slide"
                :index="index"
                :settings="settings"
                :mobile-settings="mobileSettings"
                :observer="imageObserver"
                @click="clickPostHandler(post, index)"
                ref="postImage"
              />
            </template>
          </ul>
        </div>
        <div class="swiper-scrollbar"></div>
      </div>
    </div>
    <div
      v-if="gallerySettings.branding"
      :class="[{'frisbuy-branding': true}, gallerySettings.branding ]"
    >
      Сделано на
      <a
        :href="settings.brandingLink || ('https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign='+settings.customerCode)"
        rel="nofollow"
        target="_blank"
      >
      <img :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`" alt="Frisbuy" />
      </a>
    </div>
    <div class="frisbuy-footer">
      <div
        :style="{ marginTop: gallerySettings.loadMore.marginTop + 'px'}"
        class="frisbuy-loadmore-button"
        v-if="gallerySettings.layout == 'tile' && gallerySettings.loadMore.enable && gallerySettings.loadMore.show"
        @click="loadMoreHandler"
      >
        {{ gallerySettings.loadMore.text || 'Ещё' }}
      </div>
      <div
        v-if="gallerySettings.footer.html"
        v-html="gallerySettings.footer.html"
      ></div>
    </div>
    <div
      v-if="gallerySettings.guideline.html && isGuidlineOpen"
      class="frisbuy-guideline"
    >
      <div class="frisbuy-guideline-container">
        <div v-html="gallerySettings.guideline.html"></div>
      </div>
    </div>
  </div>

  <Popup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    @changePost="(direction) => selectPost(postList[currentPostIndex + direction], currentPostIndex + direction)"
    @close="() => closePopup()"
  />
</template>

<style src="./gallery.scss" lang="scss"></style>
<style lang="scss">
.frisbuy-gallery-navigation {
  position: absolute;
  display: flex;
  justify-content: space-between;
  top: calc(50% - 15px);
  width: 100%;
  height: 0;

  &.frisbuy-big {
    top: calc(50% - 25px);

    .frisbuy-next-navigation-button,
    .frisbuy-prev-navigation-button,
    .frisbuy-navigation-button {
      width: 50px;
      height: 50px;
    }
  }

  @media (max-width: 1023px) {
    display: none;
  }
}

.frisbuy-next-navigation-button,
.frisbuy-prev-navigation-button,
.frisbuy-navigation-button {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
  border-radius: 50%;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
  cursor: pointer;

  &.frisbuy-navigation-button-disabled {
    opacity: 0.3;
  }

  svg {
    color: #131313;
    stroke-width: 2;
  }
}

/**
  /* Client Fix
  */

//goldenline
.frisbuy-widget img {
  width: unset;
}
</style>

<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";
import Popup from "../popup/popup.vue";
import FrsibuyGalleryScrollbar from "../components/FrisbuyGalleryScrollbar/FrisbuyGalleryScrollbar.vue";

import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
  mixins: [defaultGallery],

  components: {
    Popup,
    "frisbuy-gallery-scrollbar": FrsibuyGalleryScrollbar,
  },

  data() {
    return {
      scrollableGalleryQuerySelector: "#frisbuy-gallery-posts",
      galleryItemsQuerySelector: ".frisbuy-gallery-post",
      currentPostIndexInGalleryScrollWrapper: 0,
    };
  },

  computed: {
    isTablet: {
      cache: false,
      get() {
        return this.containerWidthPx <= 965;
      },
    },

    isMobile: {
      cache: false,
      get() {
        return this.containerWidthPx <= 965;
      },
    },
  },

  mounted() {
    const scrollableGallery = document.querySelector(
      this.scrollableGalleryQuerySelector
    );
    scrollableGallery.addEventListener("scroll", this.onScrollGallery);

    this.canPrevScroll = this.startPostsIndex > 0;
    this.canNextScroll = this.endPostsIndex < this.postList.length;

    new Swiper(this.$refs.swiper, {
      modules: [Navigation, Pagination, Scrollbar],

      loop: false,
      slidesPerGroup: 1,
      slidesPerView: "auto",
      spaceBetween: 24,
      simulateTouch: true,
      loadPrevNextAmount: 2,
      resistanceRatio: 0,

      breakpoints: {
        1400: {
          slidesPerView: "auto",
          spaceBetween: 40,

          scrollbar: {
            el: ".swiper-scrollbar",
            draggable: false,
            dragSize: 144,
          },
        },
      },

      navigation: {
        nextEl: ".frisbuy-next-navigation-button",
        prevEl: ".frisbuy-prev-navigation-button",
        disabledClass: "frisbuy-navigation-button-disabled",
      },

      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: false,
        dragSize: 72,
      },
    });
  },

  beforeUnmount() {
    const scrollableGallery = document.querySelector(
      this.scrollableGalleryQuerySelector
    );
    scrollableGallery.removeEventListener("scroll", this.onScrollGallery);
  },

  methods: {
    // [start] scroll mobile gallery
    onScrollGallery(e) {
      // const maxScroll = e.target.scrollWidth;
      const scrollLeft = e.target.scrollLeft;

      const scrollItemWidth =
        this.getGalleryFirstItemWidth() + this.getGalleryItemsMarginX();

      this.currentPostIndexInGalleryScrollWrapper = Math.round(
        scrollLeft / scrollItemWidth
      );
    },

    galleryScrollTo(itemIdx) {
      const scrollableGallery = document.querySelector(
        this.scrollableGalleryQuerySelector
      );

      const scrollItemWidth =
        this.getGalleryFirstItemWidth() + this.getGalleryItemsMarginX();

      scrollableGallery.scrollTo(scrollItemWidth * itemIdx, 0);
    },

    getGalleryFirstItemWidth() {
      const galleryFirstItem = document.querySelector(
        this.galleryItemsQuerySelector
      );

      return Number(galleryFirstItem.offsetWidth);
    },

    getGalleryItemsMarginX() {
      const galleryFirstItem = document.querySelectorAll(
        this.galleryItemsQuerySelector
      )[0];
      const gallerySecondItem = document.querySelectorAll(
        this.galleryItemsQuerySelector
      )[1];

      const marginOfFirstItem = this.getTranslatePxToNumber(
        window.getComputedStyle(galleryFirstItem).marginRight
      );
      const marginOfSecondItem = this.getTranslatePxToNumber(
        window.getComputedStyle(gallerySecondItem).marginLeft
      );

      const marginBetweenItems = marginOfFirstItem + marginOfSecondItem;

      return Number(marginBetweenItems);
    },

    getTranslatePxToNumber(stringInPx) {
      const pxSymbolsAmount = 2;

      return stringInPx.slice(0, stringInPx.length - pxSymbolsAmount);
    },
    // [end] scroll mobile gallery

    slideHandler(direction) {
      const scrollElement = this.widgetRefElement.querySelector(".frisbuy-scroll-wrapper");
      const widthElement = this.widgetRefElement.querySelector(".frisbuy-gallery-post");
      scrollElement.scrollBy =
        scrollElement.scrollBy ||
        ((xCoord, yCoord) => {
          scrollElement.scrollLeft = scrollElement.scrollLeft + xCoord;
          scrollElement.scrollTop = scrollElement.scrollTop + yCoord;
        });

      this.sendAnaliticEvent(`Swipe`, { swipeType: "arrow" });

      scrollElement.scrollBy({
        behavior: "smooth",
        left:
          widthElement.clientWidth * direction +
          (window.innerWidth < 1024 ? 24 : 40),
        top: 0,
      });
    },

    arrowScrollHandler() {
      // HACK: this emty func for to avoid `defaultGallery` mixin
      return;
    },
  },
};
</script>
